module.exports = __webpack_public_path__ + "static/media/choose_class_3_decoration.bf01a94b.svg";